module.exports = __webpack_public_path__ + "static/media/deepl.d5c55e5b.jpg";